/* eslint-disable react-hooks/exhaustive-deps */
/*
 * @Author: zhaotao
 * @Version:
 * @Date: 2023-04-07 13:14:09
 * @Description:
 */
import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';
export default (function (params) {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    name: 'deviceCapacityAnalysisListGet',
    method: 'GET',
  });
  useEffect(() => {
    if (params) {
      let url = `/api/device/capacity/analysis`;
      Object.keys(params).forEach((key, index) => {
        if (index === 0) {
          url += '?';
        } else {
          url += '&';
        }
        url += `${key}=${params[key]}`;
      });
      exec(url);
    }
  }, [params]);
  return [isRequestSuccessed, data || [], exec, isLoading];
});
